import API from '.';

export default class FuelBrand {
  /**
   * The fuelBrand dimension table for UDM
   * @param {number} fuelBrandId Id of the fuelBrand.
   * @param {string} fuelBrandName Name of the fuelBrand.
   * @param {string} fuelBrandDesc Description of the fuelBrand.
   */
  constructor({ fuelBrandId, fuelBrandName, fuelBrandDesc }) {
    this.fuelBrandId = fuelBrandId;
    this.fuelBrandName = fuelBrandName;
    this.fuelBrandDesc = fuelBrandDesc;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/fuelBrand');
    return data.map((d) => new FuelBrand(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`fuelBrand/${id}`);
    return new FuelBrand(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('fuelBrand', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/fuelBrand`, data);
  //   return res;
  // }
}
